import { useNavigate, useParams } from "react-router-dom";
import { Star, ArrowLeft, Building2 } from "lucide-react";
import { useVenue } from "@/context/VenueContext";
import { VenueLiveMap } from "@/components/VenueLiveMap";

export default function PlusCockpit() {
  const { groupId } = useParams();
  const navigate = useNavigate();
  const { venues, groups, setActiveVenue } = useVenue();

  const group = (groups || []).find((g) => g.id === groupId);
  const groupVenues = (venues || []).filter((v) => v.group_id === groupId);

  const enter = (venueId) => {
    setActiveVenue(venueId);
    navigate("/");
  };

  const cols = groupVenues.length >= 3 ? "lg:grid-cols-3" : groupVenues.length === 2 ? "lg:grid-cols-2" : "lg:grid-cols-1";

  return (
    <div className="min-h-screen bg-zinc-950 text-white">
      <header className="border-b border-zinc-800 px-6 py-4 flex items-center justify-between">
        <button data-testid="cockpit-logo" onClick={() => navigate("/")} className="flex items-center gap-2">
          <Star className="w-7 h-7 text-sky-400 fill-sky-400" />
          <span className="font-display font-bold text-xl">PUNTO STELLA <span className="text-sky-400">PLUS</span></span>
        </button>
        <button data-testid="cockpit-back" onClick={() => navigate("/")}
          className="flex items-center gap-2 px-3 py-1.5 rounded-xl bg-zinc-900 border border-zinc-800 hover:border-sky-500/50 text-sm">
          <ArrowLeft className="w-4 h-4" /> Home
        </button>
      </header>

      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="flex items-center gap-3 mb-1">
          <Building2 className="w-6 h-6 text-amber-400" />
          <h1 className="font-display font-bold text-2xl" data-testid="cockpit-group-name">
            {group?.nome || "Gruppo"}
          </h1>
        </div>
        <p className="text-zinc-500 text-sm mb-8">
          Cockpit live del gruppo — {groupVenues.length} sale in diretta. Clicca una sala per entrarci.
        </p>

        {groupVenues.length === 0 ? (
          <p className="text-zinc-500">Nessuna sala in questo gruppo.</p>
        ) : (
          <div className={`grid grid-cols-1 ${cols} gap-6`} data-testid="cockpit-grid">
            {groupVenues.map((v) => (
              <VenueLiveMap key={v.id} venue={v} onEnter={enter} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
